import { Module } from "vuex";
import { AuthState, AuthUser, EmailMessage, HomePageRoles, roleRouteMap } from "@/types";
import {
    codeConfirmation,
    forgotPassword,
    forgotPasswordCodeConfirmation,
    getAuthorities,
    getConfiguration,
    getDelagation,
    getSupersetConfig,
    getUser,
    signIn,
    signInSSO,
    signUp,
    updateLanguage,
    updatePassWordService
} from "@/store/services/auth";
import { getAccesToken } from "@/store/services/dashboard"
import Notify from 'quasar/src/plugins/Notify.js';;
import router from "@/router";
import { checkUserByRole, globalConfig, parseJwt, SELECTED_USER_DELEGATION, SELECTED_USER_NETWORK, SESSION_TOKEN_KEY, tokenIsValid, tokenLocalStorgeIsValid } from "@/utils";
import { getTranslations } from "@/i18n.service.handler";
import { getSpecificLanguage } from "../services/picklist";
import i18n from "@/i18n";
import { formatDateLocale } from "@/utils/configuration/formatters-config";
import store from "@/store";
import { sendMail } from "../services/task/contactMechanism";
import moment from "moment";
import { getGroupsByUserId } from "../services/task/taskService";
import { settings } from "@/settings";
import { getUserNetworks } from "../services/configuration/AuthorityService";
import { getParty } from "../services/searchThird";

function errorMessage(err: any) {
    Notify.create({
        message: err,
        color: 'negative'
    });
}

function handlingError(err: any) {
    if (err.response) {
        const status = err.response.status;
        const data = err.response.data;
        const msg = data?.message;

        let finalMessage = "An unknown error occurred.";

        if (status === 401) {
            finalMessage = "Unauthorized.";
        } 
        else if (msg && typeof msg === "object") {
            if (Array.isArray(msg.additionalInfo) && msg.additionalInfo.length > 0) {
                finalMessage = msg.additionalInfo[0].message;
            }
            else if (msg.returnMessage) {
                finalMessage = msg.returnMessage;
            }
            else if (msg.reasonPhrase) {
                finalMessage = msg.reasonPhrase;
            }
        }
        else if (typeof msg === "string") {
            finalMessage = msg;
        } 
        else {
            finalMessage = `HTTP ${status}`;
        }

        errorMessage(`Error! ${finalMessage}`);
    } 
    else {
        errorMessage(`Error! ${err.message}`);
    }

    console.error(err);
}

async function load_i18nTranslations(loggedUser: AuthUser) {
    const lang = loggedUser.defaultLanguage;
    await getTranslations(lang);

}

const authModule: Module<AuthState, any> = {
    namespaced: true,
    state: {
        user: {
            username: '',
            password: '',
            daaqList: [],
            rememberMe: false
        },
        daaqResourceUid: '',
        daaqLabel: '',
        daaq: '/',
        homeImage: false,
        msgTemplate: true,
        changePassworIn: true,
        userAuthorities: [],
        superSetConfig: undefined,
        userNetworksList: [],
        selectedUserNetwork: undefined,
        logoConfig:undefined,
        configuration: {
            superSetConfig: undefined,
            logo: undefined,
            configuration: undefined,
            workflow: undefined,
            feature_flag: undefined
        },
        partyUser: undefined,
        userPrefrences: undefined
    },
    getters: {
        getUserInit() {
            return {
                _controls: {
                    attToRemove: ['smsValidated'],
                },
                applicationName: 'TWDDistribution',
                smsValidated: false,
                rememberMe: false
            }
        },
        getSelectedUserNetwork(state) {
            return state.selectedUserNetwork;
        },
        getSelectedUserNetworkFromLocalStorage() {
            const localStorageSelectedUserNetwork = localStorage.getItem(SELECTED_USER_NETWORK) ? localStorage.getItem(SELECTED_USER_NETWORK) : undefined
            return localStorageSelectedUserNetwork;
        },
        hasMiddleOffice(state) {
            try {
                const authorities = state.user.authorities ||[];
                return authorities.some((i: { authority: string }) => i.authority?.includes('GRP_MIDDLEOFFICE'))
            }
            catch {
                return false;
            }
        },
        getUserConnected(state) {
            return state.user;
        },
        getUserConnectedFromLocalStorage() {
            let localStorageUserConnected : any = undefined
            const authModuleLocalStorage = localStorage.getItem(globalConfig.storageKeys.authModule)
            if (authModuleLocalStorage) {
                localStorageUserConnected = JSON.parse(authModuleLocalStorage)?.user;
            }
            return localStorageUserConnected;
        },
        
        getDefaultDAAQConfig(state) {
            return state.user?.daaqList &&  state.user?.daaqList[0]?.config;  
        },
        getDisable(state) {
            return false;  
        },
        getUserNetworkInit(): any {
            return {
                network: {
                    objectType: 'odm.party.network',
                    systemUid: 'odm-party',
                },
                objectType: 'odm.order.ordernetwork',
                systemUid: 'odm-order',
            }
        },
        getUserNetworkNodeInit(): any {
            return {
                networkNode: {
                    objectType: 'odm.party.networknode',
                    systemUid: 'odm-party',
                },
                objectType: 'odm.order.ordernetworknode',
                systemUid: 'odm-order',
            }
        },
        getAuthName():any{
            const tokenData = parseJwt(localStorage.getItem(SESSION_TOKEN_KEY));
            return  `${tokenData.firstName} ${tokenData.lastName}`
                    
        },
        getNetworkReseauConfiguration(state): any {
            const networkConfig =state.configuration
            && state.configuration.configuration
            && state.configuration.configuration?.find((item: any) => item && item.field === 'NETWORK_RESEAUX_ID')
              ? state.configuration.configuration?.find((item: any) => item && item.field === 'NETWORK_RESEAUX_ID')
              : undefined
            let localStorageNetworkReseauConfig : any = undefined
        
            const configurationLocalStorage = localStorage.getItem(globalConfig.storageKeys.configuration)
            if (configurationLocalStorage) {
        
               const parsedConfig = JSON.parse(configurationLocalStorage)?.configuration;
               localStorageNetworkReseauConfig = parsedConfig?.find((item: any) => item?.field === 'NETWORK_RESEAUX_ID');
                
            }
            return networkConfig || localStorageNetworkReseauConfig
        },
        getNetworkConfiguration(state): any {
            const networkConfig =state.configuration
            && state.configuration.configuration
            && state.configuration.configuration?.find((item: any) => item && item.field === 'NETWORK_ID')
              ? state.configuration.configuration?.find((item: any) => item && item.field === 'NETWORK_ID')
              : undefined
            let localStorageNetworkConfig : any = undefined
        
            const configurationLocalStorage = localStorage.getItem(globalConfig.storageKeys.configuration)
            if (configurationLocalStorage) {
        
               const parsedConfig = JSON.parse(configurationLocalStorage)?.configuration;
               localStorageNetworkConfig = parsedConfig?.find((item: any) => item?.field === 'NETWORK_ID');
                
            }
            return networkConfig || localStorageNetworkConfig
        },
        getDelagations(state) {
            return state.delegations;
        },
        
    },
    actions: {
        selectDAAQ({ commit }, payload) {
            if (payload) {
                const { daaq, daaqResourceUid, daaqLabel } = payload
                if (daaq && daaqResourceUid) {
                    commit('setDAAQ', { daaq, daaqResourceUid, daaqLabel })
                }
            }
        },
        recoverState({ commit }) {
            const prevState = localStorage.getItem(globalConfig.storageKeys.authModule)
            if (prevState) {
                const obj = JSON.parse(prevState)
                commit('setRecoverState', obj)
            }
        },
        async initializeAuth({ commit, getters }) {
            const tokenValid = tokenIsValid();
            const _token = tokenLocalStorgeIsValid();
            if (tokenValid) { 
                const authUser = getters.getUserInit;
                const tokenData = parseJwt(localStorage.getItem(SESSION_TOKEN_KEY));
                authUser.loggedIn = tokenValid;
                authUser.username = tokenData.username;
                authUser.firstName = tokenData.firstName;
                authUser.lastName = tokenData.lastName;
                authUser.email = tokenData.email;
                authUser.userId = tokenData.userResourceUid;
                authUser.applicationName = tokenData.applicationName;
                const { daaq } = tokenData
                if (daaq && daaq.length) {
                    authUser.daaqList = tokenData.daaq.map((item: any) => {
                        return {
                            label: item.label,
                            value: item.resourceUid,
                            config: { ...item }
                        }
                    });
                    const firstDAAQ = authUser.daaqList[0].config
                    commit('setDAAQ', { daaq: firstDAAQ.daaq, daaqResourceUid: firstDAAQ.resourceUid, daaqLabel: firstDAAQ.label })
                }
                commit('setUserPrefrences', undefined);
                const user = await getUser(tokenData.userResourceUid);
                commit('setUserPrefrences', user?.data);
                const authorities = tokenData.auth.split(',').map((auth: string) => ({ authority: auth.trim() }));
                const authoritiesWithResourceUid = Array.isArray(authorities)
                    && authorities.some((item: any) => item && item.resourceUid);
                if (authoritiesWithResourceUid) {
                    authUser.authorities = authorities;
                } else {
                    const response = await getAuthorities()
                    authUser.authorities = response.data.authorities
                }

                const data = await getSpecificLanguage({ languages: user.data.preferredLanguages.map((lang: any) => lang.language) })
                const preferredLanguages: any[] = []
                data.items.forEach((lang: any) => {
                    preferredLanguages.push(lang);
                });
                authUser.preferredLanguages = preferredLanguages;

                const defaultLanguage = data.items.find((lang: any) => lang.id === user.data.defaultLanguage)
                authUser.defaultLanguage = defaultLanguage;

                commit('setUser', authUser);

                await getTranslations(authUser.defaultLanguage, true);
               

                if(user&&user.data&&user.data.associatedParty&&user.data.associatedParty){
                    commit('setPartyUid', user.data.associatedParty);

                }
                const delagation=await getDelagation(tokenData.userResourceUid)
                commit('setDelegations', delagation);

                const selectedUserDelegation ={value:tokenData.userResourceUid,
                    label:tokenData.firstName+' '+tokenData.lastName,
                    rawData:authorities
                }
                const localStorageDelegation = localStorage.getItem(SELECTED_USER_DELEGATION); 
                if(localStorageDelegation){
                    const delegationJson = JSON.parse(localStorageDelegation); 
                    commit('setSelectedUserDelegation', delegationJson);
                    if (delegationJson.rawData.token) {

                        const cleanToken = delegationJson.rawData.token.replace("Bearer ", "");
                        
                        const tokenData = parseJwt(cleanToken);
                        authUser.loggedIn = true;
                        authUser.username = tokenData.username;
                        authUser.firstName = tokenData.firstName;
                        authUser.lastName = tokenData.lastName;
                        authUser.email = tokenData.email;
                        authUser.userId = tokenData.userResourceUid;
                        authUser.applicationName = tokenData.applicationName;
                        const { daaq } = tokenData
                        if (daaq && daaq.length) {
                            authUser.daaqList = tokenData.daaq.map((item: any) => {
                                return {
                                    label: item.label,
                                    value: item.resourceUid,
                                    config: { ...item }
                                }
                            });
                            const firstDAAQ = authUser.daaqList[0].config
                            commit('setDAAQ', { daaq: firstDAAQ.daaq, daaqResourceUid: firstDAAQ.resourceUid, daaqLabel: firstDAAQ.label })
                        }
                        commit('setUserPrefrences', undefined);
                        const user = await getUser(tokenData.userResourceUid);
                        commit('setUserPrefrences', user?.data); 
        
                        
                        authUser.authorities = delegationJson.rawData.authorities
                        const defaultLanguage = await getSpecificLanguage({ language: user.data.defaultLanguage })
                        authUser.defaultLanguage = defaultLanguage.items[0]
                        const preferredLanguages = []
                        for (const language of user.data.preferredLanguages) {
                            const defaultLanguage = await getSpecificLanguage({ language: language.language })
                            preferredLanguages.push(defaultLanguage.items[0])
                        }
        
                        authUser.preferredLanguages = preferredLanguages
                        commit('setUser', authUser);
        
                        await getTranslations(authUser.defaultLanguage, true);
                       
        
                        if(user&&user.data&&user.data.associatedParty&&user.data.associatedParty){
                            commit('setPartyUid', user.data.associatedParty);
        
                        }
        
                    }
                }else{
                    commit('setSelectedUserDelegation', selectedUserDelegation);
                }
                let filter={module:'CONFIGURATION'}
                let module = filter && filter.module ? filter.module : undefined
                await getConfiguration(filter)
                .then((response) => { commit('setConfiguration', {module, payload: response });
                })
                  filter={module:'LOGO'}
                  module = filter && filter.module ? filter.module : undefined
                await getConfiguration(filter)
                .then((response) => { commit('setConfiguration', {module, payload: response });
                })
                  filter={module:'WORKFLOW'}
                  module = filter && filter.module ? filter.module : undefined
                await getConfiguration(filter)
                .then((response) => { commit('setConfiguration', {module, payload: response });
                })
                 filter={module:'FEATURE_FLAG'}
                  module = filter && filter.module ? filter.module : undefined
                await getConfiguration(filter)
                .then((response) => { commit('setConfiguration', {module, payload: response });
                })

            }
            else if (_token){ 
                const authUser = getters.getUserInit;
                const tokenData = parseJwt(localStorage.getItem(SESSION_TOKEN_KEY));
                authUser.loggedIn = _token;
                authUser.username = tokenData.username;
                authUser.firstName = tokenData.firstName;
                authUser.lastName = tokenData.lastName;
                authUser.email = tokenData.email;
                authUser.userId = tokenData.userResourceUid;
                authUser.applicationName = tokenData.applicationName;
                const { daaq } = tokenData
                if (daaq && daaq.length) {
                    authUser.daaqList = tokenData.daaq.map((item: any) => {
                        return {
                            label: item.label,
                            value: item.resourceUid,
                            config: { ...item }
                        }
                    });
                    const firstDAAQ = authUser.daaqList[0].config
                    commit('setDAAQ', { daaq: firstDAAQ.daaq, daaqResourceUid: firstDAAQ.resourceUid, daaqLabel: firstDAAQ.label })
                }
                commit('setUserPrefrences', undefined);
                const user = await getUser(tokenData.userResourceUid);
                commit('setUserPrefrences', user?.data); 
                const response = await getAuthorities()
                authUser.authorities = response.data.authorities
                const defaultLanguage = await getSpecificLanguage({ language: user.data.defaultLanguage })
                authUser.defaultLanguage = defaultLanguage.items[0]
                
                const preferredLanguages = []
                for (const language of user.data.preferredLanguages) {
                    const defaultLanguage = await getSpecificLanguage({ language: language.language })
                    preferredLanguages.push(defaultLanguage.items[0])
                }

                authUser.preferredLanguages = preferredLanguages
                commit('setUser', authUser);

                await getTranslations(authUser.defaultLanguage, true);


                if(user&&user.data&&user.data.associatedParty&&user.data.associatedParty){
                    commit('setPartyUid', user.data.associatedParty);

                }

                const delagation=await getDelagation(tokenData.userResourceUid)
                commit('setDelegations', delagation);

                const selectedUserDelegation ={value:tokenData.userResourceUid,
                    label:tokenData.firstName+' '+tokenData.lastName,
                    rawData:response.data
                }
                const localStorageDelegation = localStorage.getItem(SELECTED_USER_DELEGATION); 
                if(localStorageDelegation){
                    const delegationJson = JSON.parse(localStorageDelegation); 
                    commit('setSelectedUserDelegation', delegationJson);
                    if (delegationJson.rawData.token) {

                        const cleanToken = delegationJson.rawData.token.replace("Bearer ", ""); 
                        const tokenData = parseJwt(cleanToken);
                        authUser.loggedIn = true;
                        authUser.username = tokenData.username;
                        authUser.firstName = tokenData.firstName;
                        authUser.lastName = tokenData.lastName;
                        authUser.email = tokenData.email;
                        authUser.userId = tokenData.userResourceUid;
                        authUser.applicationName = tokenData.applicationName;
                        const { daaq } = tokenData
                        if (daaq && daaq.length) {
                            authUser.daaqList = tokenData.daaq.map((item: any) => {
                                return {
                                    label: item.label,
                                    value: item.resourceUid,
                                    config: { ...item }
                                }
                            });
                            const firstDAAQ = authUser.daaqList[0].config
                            commit('setDAAQ', { daaq: firstDAAQ.daaq, daaqResourceUid: firstDAAQ.resourceUid, daaqLabel: firstDAAQ.label })
                        }
                        commit('setUserPrefrences', undefined);
                        const user = await getUser(tokenData.userResourceUid);
                        commit('setUserPrefrences', user?.data); 
        
                        
                        authUser.authorities = delegationJson.rawData.authorities
                        const defaultLanguage = await getSpecificLanguage({ language: user.data.defaultLanguage })
                        authUser.defaultLanguage = defaultLanguage.items[0]
                        const preferredLanguages = []
                        for (const language of user.data.preferredLanguages) {
                            const defaultLanguage = await getSpecificLanguage({ language: language.language })
                            preferredLanguages.push(defaultLanguage.items[0])
                        }
        
                        authUser.preferredLanguages = preferredLanguages
                        commit('setUser', authUser);
        
                        await getTranslations(authUser.defaultLanguage, true);
                       
        
                        if(user&&user.data&&user.data.associatedParty&&user.data.associatedParty){
                            commit('setPartyUid', user.data.associatedParty);
        
                        }
        
                    }
                }else{
                    commit('setSelectedUserDelegation', selectedUserDelegation);
                }
                let filter={module:'CONFIGURATION'}
                let module = filter && filter.module ? filter.module : undefined
                await getConfiguration(filter)
                .then((response) => { commit('setConfiguration', {module, payload: response });
                })
                  filter={module:'LOGO'}
                  module = filter && filter.module ? filter.module : undefined
                await getConfiguration(filter)
                .then((response) => { commit('setConfiguration', {module, payload: response });
                })
                  filter={module:'WORKFLOW'}
                  module = filter && filter.module ? filter.module : undefined
                await getConfiguration(filter)
                .then((response) => { commit('setConfiguration', {module, payload: response });
                })
                 filter={module:'FEATURE_FLAG'}
                  module = filter && filter.module ? filter.module : undefined
                await getConfiguration(filter)
                .then((response) => { commit('setConfiguration', {module, payload: response });
                })
            }
            else {
                const currentPath = window.location.pathname;
                if (currentPath !== '/oidc-callback' && !currentPath.startsWith('/external/')) {
                    router.push('/login').catch(err => errorMessage('Error! ' + err));
                }
            }
        },
        async signIn({ commit, getters, dispatch }, payload) {
            const redirectToChangePassword = () => {
                commit('setChangePassWordIn', false);
                router.push('/changePassword').catch(err => errorMessage('Error! ' + err));
            };
            payload.login = payload.username;
            payload.rememberMe = payload.rememberMe || false; // Use checkbox value, default to false
            payload.applicationName = getters.getUserInit.applicationName;
            try {
                const token = await signIn(payload)
                localStorage.setItem(SESSION_TOKEN_KEY, token);
                const loggedUser = getters.getUserInit;

                const response = await getAuthorities()
                loggedUser.authorities = response.data.authorities
                loggedUser.temporaryPassword = response.data.temporaryPassword
                loggedUser.passwordExpirationDate = response.data.passwordExpirationDate
                const tokenData = parseJwt(token);
                loggedUser.resourceUid = tokenData.userResourceUid;
                loggedUser.userId = tokenData.userResourceUid;
                loggedUser.username = tokenData.username;
                loggedUser.firstName = tokenData.firstName;
                loggedUser.lastName = tokenData.lastName;
                loggedUser.email = tokenData.email;
                loggedUser.applicationName = tokenData.applicationName;
                const selectedUserDelegation ={value:tokenData.userResourceUid,
                    label:tokenData.firstName+' '+tokenData.lastName,
                    rawData:response.data
                }
                commit('setSelectedUserDelegation', selectedUserDelegation);
                const { daaq } = tokenData
                if (daaq && daaq.length) {
                    loggedUser.daaqList = tokenData.daaq.map((item: any) => {
                        return {
                            label: item.label,
                            value: item.resourceUid,
                            config: { ...item }
                        }
                    });
                    const firstDAAQ = loggedUser.daaqList[0].config
                    commit('setDAAQ', { daaq: firstDAAQ.daaq, daaqResourceUid: firstDAAQ.resourceUid, daaqLabel: firstDAAQ.label })
                }
                commit('setUserPrefrences', undefined);
                const user = await getUser(tokenData.userResourceUid);
                commit('setUserPrefrences', user?.data); 
                const defaultLanguage = await getSpecificLanguage({ language: user.data.defaultLanguage })
                const delagation=await getDelagation(tokenData.userResourceUid)
                commit('setDelegations', delagation);

                loggedUser.defaultLanguage = defaultLanguage.items[0]
                loggedUser.selectedLanguage = loggedUser.defaultLanguage

                await load_i18nTranslations(loggedUser);
                const preferredLanguages = []
                for (const language of user.data.preferredLanguages) {
                    const defaultLanguage = await getSpecificLanguage({ language: language.language })
                    preferredLanguages.push(defaultLanguage.items[0])
                }
                loggedUser.preferredLanguages = preferredLanguages

                if ((loggedUser.temporaryPassword ||
                    (loggedUser.passwordExpirationDate && moment(loggedUser.passwordExpirationDate, "DD/MM/YYYY").isBefore(moment())))) {
                    commit('setMsgTemplate', loggedUser.temporaryPassword);
                    commit('setUser', loggedUser);
                    if(user&&user.data&&user.data.associatedParty&&user.data.associatedParty){
                        commit('setPartyUid', user.data.associatedParty);

                    }
                    redirectToChangePassword();

                }
                else {     
                    await store.dispatch("authModule/getSupersetConfig", { 
                        filter: { module: 'SUPERSET' } 
                      })
                    loggedUser.loggedIn = true;
                    commit('setUser', loggedUser);
                    if(user&&user.data&&user.data.associatedParty&&user.data.associatedParty){
                        commit('setPartyUid', user.data.associatedParty);
                    }
                    await getAccesToken(store.state.authModule?.superSetConfig);
                    const homePageRolesKeys = Object.keys(HomePageRoles);
                    const userConnected = store.getters["authModule/getUserConnected"];
                    await store.dispatch("authModule/getConfiguration", { 
                        filter: { module: 'LOGO' } 
                      })
                    await store.dispatch("authModule/getConfiguration", { 
                        filter: { module: 'CONFIGURATION' } 
                    })
                    await store.dispatch("authModule/getConfiguration", { 
                        filter: { module: 'WORKFLOW' } 
                    })
                    await store.dispatch("authModule/getConfiguration", { 
                        filter: { module: 'FEATURE_FLAG' } 
                    })
                    const partyPersonId = userConnected && userConnected.partyPersonId && userConnected.partyPersonId.resourceUid 
                                          ? userConnected.partyPersonId.resourceUid  
                                          : undefined
                    const partyUser = await getParty("frenchPerson", partyPersonId);
                    commit('setPartyUser', partyUser);  
                    const userGroupList: any = getGroupsByUserId() 

                // Déterminer la route cible selon les rôles
                let matchedRoute = '/home';
                for (const key of homePageRolesKeys) {
                    const value: any = (HomePageRoles as any)[key];
                    if (checkUserByRole([key])) {
                        matchedRoute = '/' + value;
                        break;
                    }
                }

                if (matchedRoute === '/home') {
                    for (const role of Object.keys(roleRouteMap)) {
                        const hasRole = userGroupList.items?.find((el: any) =>
                            el.label.includes(role)
                        );
                        if (hasRole) {
                            matchedRoute = roleRouteMap[role];
                            break;
                        }
                    }
                }
                // Attendre du temps pour détecter une navigation manuelle
                  setTimeout(() => {
                   const currentPath = router.currentRoute.value.path;
                
                   // Si l'utilisateur n'a pas encore changé de page, on redirige
                    if (currentPath === '/' || currentPath === '/login' || currentPath === '/home') {
                        router.push(matchedRoute).catch((err) => errorMessage('Error! ' + err));
                    } else {
                        console.log('Navigation manuelle détectée, redirection annulée (page actuelle:', currentPath, ')');
                    }
                  }, 2000);      
                }

            } catch (err) {
                handlingError(err)
            }
        },
        async signInSSO({ commit, getters, dispatch }, payload) {
            try {
                // SSO authentication uses a different payload structure
                const token = await signInSSO(payload);
                localStorage.setItem(SESSION_TOKEN_KEY, token);
                
                const loggedUser = getters.getUserInit;
                const response = await getAuthorities();
                loggedUser.authorities = response.data.authorities;
                loggedUser.temporaryPassword = response.data.temporaryPassword;
                loggedUser.passwordExpirationDate = response.data.passwordExpirationDate;
                
                const tokenData = parseJwt(token);
                loggedUser.resourceUid = tokenData.userResourceUid;
                loggedUser.userId = tokenData.userResourceUid;
                loggedUser.username = tokenData.username;
                loggedUser.firstName = tokenData.firstName;
                loggedUser.lastName = tokenData.lastName;
                loggedUser.email = tokenData.email;
                loggedUser.applicationName = tokenData.applicationName;
                
                const selectedUserDelegation = {
                    value: tokenData.userResourceUid,
                    label: tokenData.firstName + ' ' + tokenData.lastName,
                    rawData: response.data
                };
                commit('setSelectedUserDelegation', selectedUserDelegation);
                
                const { daaq } = tokenData;
                if (daaq && daaq.length) {
                    loggedUser.daaqList = tokenData.daaq.map((item: any) => {
                        return {
                            label: item.label,
                            value: item.resourceUid,
                            config: { ...item }
                        };
                    });
                    const firstDAAQ = loggedUser.daaqList[0].config;
                    commit('setDAAQ', { 
                        daaq: firstDAAQ.daaq, 
                        daaqResourceUid: firstDAAQ.resourceUid, 
                        daaqLabel: firstDAAQ.label 
                    });
                }
                
                commit('setUserPrefrences', undefined);
                const user = await getUser(tokenData.userResourceUid);
                commit('setUserPrefrences', user?.data); 
                
                const defaultLanguage = await getSpecificLanguage({ language: user.data.defaultLanguage });
                const delagation = await getDelagation(tokenData.userResourceUid);
                commit('setDelegations', delagation);

                loggedUser.defaultLanguage = defaultLanguage.items[0];
                loggedUser.selectedLanguage = loggedUser.defaultLanguage;

                await load_i18nTranslations(loggedUser);
                
                const preferredLanguages = [];
                for (const language of user.data.preferredLanguages) {
                    const defaultLanguage = await getSpecificLanguage({ language: language.language });
                    preferredLanguages.push(defaultLanguage.items[0]);
                }
                loggedUser.preferredLanguages = preferredLanguages;
                    
                await store.dispatch("authModule/getSupersetConfig", { 
                    filter: { module: 'SUPERSET' } 
                });
                loggedUser.loggedIn = true;
                commit('setUser', loggedUser);
                if(user && user.data && user.data.associatedParty && user.data.associatedParty){
                    commit('setPartyUid', user.data.associatedParty);
                }
                await getAccesToken(store.state.authModule?.superSetConfig);
                const homePageRolesKeys = Object.keys(HomePageRoles);
                const userConnected = store.getters["authModule/getUserConnected"];
                await store.dispatch("authModule/getConfiguration", { 
                    filter: { module: 'LOGO' } 
                });
                await store.dispatch("authModule/getConfiguration", { 
                    filter: { module: 'CONFIGURATION' } 
                });
                await store.dispatch("authModule/getConfiguration", { 
                    filter: { module: 'WORKFLOW' } 
                });
                await store.dispatch("authModule/getConfiguration", { 
                    filter: { module: 'FEATURE_FLAG' } 
                });
                const partyPersonId = userConnected && userConnected.partyPersonId && userConnected.partyPersonId.resourceUid 
                                        ? userConnected.partyPersonId.resourceUid  
                                        : undefined;
                const partyUser = await getParty("frenchPerson", partyPersonId);
                commit('setPartyUser', partyUser);  
                const userGroupList: any = getGroupsByUserId();
                homePageRolesKeys.forEach(async (key: any) => {
                    const value: any = (HomePageRoles as any)[key];
                    if (checkUserByRole([key])) {
                        router.push('/' + value).catch(err => errorMessage('Error! ' + err));   
                        return;
                    } else {
                        let matchedRoute = '/home';
                        for (const role of Object.keys(roleRouteMap)) {
                            const hasRole = userGroupList.items?.find(
                                (el: any) => el.label.includes(role)
                            );
                            
                            if (hasRole) {
                                matchedRoute = roleRouteMap[role];
                                break;
                            }
                        }
                        router.push(matchedRoute).catch(err => errorMessage('Error! ' + err));
                    }
                });

            } catch (err) {
                handlingError(err);
                router.push('/login_no_sso').catch(err => errorMessage('Error! ' + err));
            }
        },
        async changeUserDelegation({ commit, getters, dispatch }, payload){
            const {rawData}=payload
            // le compte d'origine n'a pas de token dans la liste des délégations,
            // on reprend alors le token de la session pour recharger ses données (rôle, DAAQ...).
            const token = rawData?.token ? rawData.token.replace("Bearer ", "") : localStorage.getItem(SESSION_TOKEN_KEY);
            if (token) {
                const cleanToken = token;
                
                const authUser = getters.getUserInit;
                const tokenData = parseJwt(cleanToken);
                authUser.loggedIn = true;
                authUser.username = tokenData.username;
                authUser.firstName = tokenData.firstName;
                authUser.lastName = tokenData.lastName;
                authUser.email = tokenData.email;
                authUser.userId = tokenData.userResourceUid;
                authUser.applicationName = tokenData.applicationName;
                const { daaq } = tokenData
                if (daaq && daaq.length) {
                    authUser.daaqList = tokenData.daaq.map((item: any) => {
                        return {
                            label: item.label,
                            value: item.resourceUid,
                            config: { ...item }
                        }
                    });
                    const firstDAAQ = authUser.daaqList[0].config
                    commit('setDAAQ', { daaq: firstDAAQ.daaq, daaqResourceUid: firstDAAQ.resourceUid, daaqLabel: firstDAAQ.label })
                }
                const user = await getUser(tokenData.userResourceUid);

                
                authUser.authorities = rawData?.token ? rawData.authorities : (await getAuthorities()).data.authorities
                const defaultLanguage = await getSpecificLanguage({ language: user.data.defaultLanguage })
                authUser.defaultLanguage = defaultLanguage.items[0]
                const preferredLanguages = []
                for (const language of user.data.preferredLanguages) {
                    const defaultLanguage = await getSpecificLanguage({ language: language.language })
                    preferredLanguages.push(defaultLanguage.items[0])
                }

                authUser.preferredLanguages = preferredLanguages
                commit('setUser', authUser);

                await getTranslations(authUser.defaultLanguage, true);
               

                if(user&&user.data&&user.data.associatedParty&&user.data.associatedParty){
                    commit('setPartyUid', user.data.associatedParty);

                }
                router.push('/home')

            }

        },
        signUp({ commit, getters }, payload) {
            const { username } = payload
            signUp(payload).then(res => {
                res.smsCode = '';
                res.username = username;
                commit('setUser', { ...getters.getUserInit, ...res });
                Notify.create({
                    message: `Success! User ${res.userId} created.`,
                    color: 'positive'
                });
            }).catch(err => {
                handlingError(err);
                commit('setUser', getters.getUserInit);
                router.push('/login').catch(() => errorMessage('Error! ' + err));
            });
        },
        signOut({ dispatch, getters }, options?: { callback: () => void }) {
            const loggedUser = getters.getUserInit;
            loggedUser.loggedIn = false;
            sessionStorage.clear();
            localStorage.clear();
            dispatch('cleanUser');
            store.dispatch('filterModule/resetFilterState');

            const isOidcEnabled =
                settings.oidc.enabled === true || settings.oidc.enabled === 'true';

            const loginRoute = isOidcEnabled ? '/login' : '/login_no_sso';
            router.push(loginRoute).catch(err => errorMessage('Error! ' + err));

            if (options && options.callback) {
                options.callback();
            }
        },
        codeConfirmation({ commit, getters }, payload) {
            codeConfirmation(payload).then(res => {
                commit('setUser', getters.getUserInit);
                commit('validateCode', res);
                Notify.create({
                    message: `Success! ${res.result}`,
                    color: 'positive'
                });
                router.push('/login').catch(err => errorMessage('Error! ' + err));
            }).catch(err => handlingError(err));
        },
        forgotPassword({ commit, getters }, payload) {
            forgotPassword(payload).then(() => {
                commit('setUser', getters.getUserInit);
                commit('forgotPassword', payload);
                Notify.create({
                    message: i18n.global.t("main.connect.sendCodeMessage"),
                    color: 'positive'
                });
            }).catch(err => handlingError(err));
        },
        forgotPasswordCodeConfirmation({ commit, getters }, payload) {
            forgotPasswordCodeConfirmation(payload).then(() => {
                Notify.create({
                    message: `Success! Forgot Password code validated.`,
                    color: 'positive'
                });
                store.dispatch("authModule/sendEmailNotification",store.state.authModule?.user);
                commit('setUser', getters.getUserInit);
            }).catch(err => {
                handlingError(err)
            });
        },
        cleanUser({ commit }, payload) {
            commit('setInitial');
        },
        saveLanguage({ commit, getters }, payload) {
            const { userId, defaultLanguage, listAvailableLanguage } = payload
            getUser(userId).then(res => {
                res.data.preferredLanguages = listAvailableLanguage
                res.data.defaultLanguage = defaultLanguage
                if (res.data.passwordExpirationDate) {
                    res.data.passwordExpirationDate = formatDateLocale(res.data.passwordExpirationDate, i18n.global.t("mask.format"), 'en', 'YYYY-MM-DD')
                }
                updateLanguage(res.data, userId).then((response: any) => {
                    commit('setLanguage', response);
                }
                )
            })
        },
          async saveUserPreferences({ commit, getters }, payload) {
            const { user, callback} = payload
                    if (user?.passwordExpirationDate) {
                    user.passwordExpirationDate = formatDateLocale(user?.passwordExpirationDate, i18n.global.t("mask.format"), 'en', 'YYYY-MM-DD')
                   }
                   await updateLanguage(user, user.resourceUid)
                           .then(async (res:any) => {
                            const userId = res?.data?.resourceUid
                            const user = await getUser(userId);
                            commit('setUserPrefrences', user?.data); 
                            Notify.create({
                                   message: i18n.global.t('main.dialog.success', { entity: res.data?.resourceUid }),
                                   color: "positive",
                            })
                            if (callback){
                              callback();
                           }
                        })
                        .catch((e:any) => console.error(e))
        },
        async sendEmailNotification({ commit },payload){
            const body: EmailMessage = {
                objectType: "odm.contactmechanism.communicationrequest.emailmessage",
                clientApplication: {
                    objectType: "odm.contactmechanism.contactmechanismclient",
                    systemUid: "odm-contactmechanism",
                    resourceUid: "ApplicationClient"
                },
                emailTemplate: {
                    objectType: "contactmechanism-EmailTemplate",
                    systemUid: "odm-contactmechanism",
                    resourceUid: "UpdatePasswordNotificationTemplate"
                },
                parameters: {
                    email: payload.email,
                    signatory_cc: payload.email
                }
            }
            await sendMail(body)
        },
        async updatePassword({ commit }, payload) {
            try {
                await updatePassWordService(payload).then(async (response: any) => {
                    const userId = store.state.authModule?.user.userId  ? store.state.authModule?.user.userId : ''
                    const res=   await getUser(userId)
                    res.data.temporaryPassword = false
                    if (res.data.passwordExpirationDate) {
                        res.data.passwordExpirationDate = formatDateLocale(res.data.passwordExpirationDate, i18n.global.t("mask.format"), 'en', 'YYYY-MM-DD')
                    }
                      await updateLanguage(res.data, userId)
                    }
                )                
                Notify.create({
                    message: i18n.global.t("main.connect.changePasswordMessageSuccessfully"),
                    color: "positive",
                });
                commit('setChangePassWordIn', true)
                store.dispatch("authModule/sendEmailNotification",store.state.authModule?.user);
                store.dispatch("authModule/signOut");
            } catch (error) {

                Notify.create({
                    message: "Please do not repeat the same password that you already used in last 3 times",
                    color: "negative",
                });

            }

        },
        async getSupersetConfig({ commit }, payload) {
            const { filter} = payload;
            await getSupersetConfig(filter)
              .then((response) => {
                commit('setSupersetConfig',response);
              })
              .catch((err) => {
                console.error(err);
              });
        },
        async getLogoConfig({ commit }, payload) {
            const { filter,callback} = payload;
            await getConfiguration(filter)
              .then((response) => {
                if (callback){
                callback(response)
                }
                else {  
                commit('setLogoConfig',response);
               }
              })
              .catch((err) => {
                console.error(err);
              });
        },
        async getConfiguration({ commit }, payload) {
            const { filter,callback} = payload;
            const module = filter && filter.module ? filter.module : undefined
            await getConfiguration(filter)
              .then((response) => {
                if (callback){
                callback(response)
                }
                else {  
                commit('setConfiguration', { module, payload: response });
               }
              })
              .catch((err) => {
                console.error(err);
              });
        },
        userNetworks({ commit }, payload) {
            const { filter,callback } = payload
            getUserNetworks(filter)
                .then(res => {
                    if (res.items.length > 0 ) {
                        commit('setUserNetworksList', res.items);
                        callback(res.items);
                    } 
                })
                .catch(() => {})
        },
        setSelectedUserNetwork({ commit }, payload) {
         const { network } = payload
         commit('setSelectedUserNetwork', network);  
        },
        setSelectedUserDelegation({ commit }, payload) {
            const { user } = payload
            commit('setSelectedUserDelegation', user);  
           },
        setUserPrefrencesPreferenceCol({ commit }, payload) {
            commit('setUserPrefrencesPreferenceCol', payload);  
           }
        
    },
    mutations: {
        setInitial(state) {
            state.user = {
                username: '',
                password: '',
                daaqList: [],
                rememberMe: false
            },
                state.daaqResourceUid = '',
                state.daaqLabel = '',
                state.daaq = '/'
        },
        setRecoverState(state, payload) {
            state.user = payload.user ? payload.user : ''
        },
        setUser(state, payload) {
            state.user = payload;
        },
        validateCode(state, payload) {
            state.user.smsValidated = !!payload;
        },
        forgotPassword(state, payload) {
            state.user.forgotPassword = true;
            state.user.smsCode = '';
            state.user.username = payload.username;
        },
        setDAAQ(state, payload) {
            state.daaq = payload.daaq
            state.daaqResourceUid = payload.daaqResourceUid
            state.daaqLabel = payload.daaqLabel
        },
        setMsgTemplate(state, payload) {
            state.msgTemplate = payload;
        },
        setChangePassWordIn(state, payload) {
            state.changePassworIn = payload;
        },
        setPartyUid(state, payload){
            state.user.partyPersonId=payload
        },
        setPartyUser(state, payload){
            state.partyUser=payload
        },
        async setLanguage(state, payload) {
            try {
                const { defaultLanguage, preferredLanguages } = payload.data;

                const defaultLanguagePromise = getSpecificLanguage({ language: defaultLanguage });
                const preferredLanguagesPromises = preferredLanguages.map((language: any) =>
                    getSpecificLanguage({ language: language.language })
                );

                const [defaultLanguageResult, ...preferredLanguagesResults] = await Promise.all([
                    defaultLanguagePromise,
                    ...preferredLanguagesPromises,
                ]);

                state.user.defaultLanguage = defaultLanguageResult.items[0];
                state.user.preferredLanguages = preferredLanguagesResults.map((result: any) => result.items[0]);
                state.user.selectedLanguage = defaultLanguageResult.items[0];
            } catch (error) {
                console.error("Error setting language:", error);
            }
        },
        setSupersetConfig(state, payload) {
            state.superSetConfig = payload;
        },
        setUserNetworksList(state, payload) {
            state.userNetworksList = payload
        },
        setSelectedUserNetwork(state, payload) {
            state.selectedUserNetwork = payload
            localStorage.setItem(SELECTED_USER_NETWORK,payload.value );
        },
        setSelectedUserDelegation(state, payload) {
            localStorage.setItem(SELECTED_USER_DELEGATION,JSON.stringify(payload));  
            state.selectedUserDelegation = payload
        },
        
        setLogoConfig(state, payload) {
            state.logoConfig = payload;
        },
        setDelegations(state, payload) {
            state.delegations = payload;
        },
        setConfiguration(state, { module, payload }) {
            const key = module.toLowerCase() 
            if (key in state.configuration) {
                state.configuration[key] = payload;
            }
        },
        setUserPrefrences(state, payload) {
            state.userPrefrences = payload;
        },
        setUserPrefrencesPreferenceCol(state, payload) {
            state.userPrefrences.preferenceCol[payload.moduleName].columns = payload.columns;
        }
    },
}

export default authModule;
